<template>
  <div class="block-btn_toggle default-btn flex flex-row items-center">
    <input
        :id="id"
        :name="name"
        type="checkbox"
        class="btn_toggle relative outline-none appearance-none left-0 flex w-reg_28 h-reg_16 bg-reg_white rounded-full cursor-pointer"
        :checked="internalValue"
        :disabled="disabledState"
        @click="onChange"
    >

    <div v-if="showPopup">
      <div class="overlay bg-reg_black_90 z-90 fixed top-0 left-0 right-0 bottom-0 transition-none"></div>
      <div class="fixed z-100 top-0 left-0 right-0 bottom-0 m-auto flex justify-center items-center">
        <div class="modal-block rounded bg-reg_white p-reg_24" style="width: 350px;">
          <div class="modal-block_header relative">

            <h3 class="modal-block_title text-sm_reg text-reg_black font-semibold">{{popup.title}}</h3>

            <button class="btn_close absolute flex items-center justify-center right-0 top-0 rounded-full w-reg_32 h-reg_32 mt-reg_10_m mr-reg_10_m" @click="closePopup" type="button">
              <svg-icon name="icon__close" class="icon__close w-reg_18 h-reg_18 fill-reg_black_75" />
            </button>
          </div>
          <div class="modal-block_body">

            <div class="flex flex-row justify-between mt-reg_24">
              <button type="button" @click="submitToggle" class="block w-full rounded bg-reg_red text-reg_white text-sm_reg py-reg_10">{{popup.submit}}</button>
            </div>

            <div class="flex flex-row justify-between mt-reg_12">
              <button type="button" class="block w-full rounded bg-reg_gray text-reg_black_75 text-sm_reg py-reg_10" @click="closePopup">{{popup.deny}}</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import SvgIcon from "@/components/ui/svgicon.vue";

export default {
  name: 'toggle',
  components: {SvgIcon},
  props: {
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    deactivateMode: {
      type: Boolean,
      default: false,
    },
    submitMode: {
      type: Boolean,
      default: false,
    },
    popup: {
      type: Object,
      default: () => ({
        title: 'Подтвердите выбранное действие',
        submit: 'Подтверждаю',
        deny: 'Отмена',
      })
    }
  },
  computed: {
    disabledState() {
      if (this.disabled){
        return true;
      }

      return this.deactivateMode && !this.internalValue;
    }
  },
  data() {
    return {
      internalValue: this.value,
      showPopup: false
    };
  },
  watch: {
    value(newVal) {
      console.log(newVal);
      this.internalValue = newVal;
    }
  },
  methods: {
    onChange(e) {
      if(this.submitMode){
        e.preventDefault();
        this.showPopup = true;
        return;
      }
      this.toggle();
    },

    closePopup() {
      this.showPopup = false;
    },

    toggle() {
      this.internalValue = !this.internalValue;
      this.$emit('change', this.internalValue);
    },

    submitToggle() {
      this.toggle();
      this.closePopup();
    }
  }
};
</script>
